var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-section',{attrs:{"id":"404"}},[_c('v-card',{staticStyle:{"height":"calc(100vh - 156px)","align-content":"center","display":"grid"},attrs:{"elevation":"0"}},[_c('base-heading',{attrs:{"title":"404"}}),_c('base-subheading',{attrs:{"space":"8","title":"NOT Found"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }